import React from "react";
import { FormText } from "reactstrap";
import { CptSelector as BaseCptSelector } from "../CptSelector";
import { InputWrapper } from "./InputWrapper";

export const CptSelector = ({ children, input, label, meta, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper label={label} required={rest.required} data-testid={rest["data-testid"]}>
      <BaseCptSelector valid={!invalid} {...input} {...rest} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}
      {children}
    </InputWrapper>
  );
};
